import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../utils/fetchFunctions";
import { isPasswordValid } from "../utils/passwordUtils";
import FormContainer from "../components/FormContainer";
import Button from "../components/Button";
import InputField from "../components/InputField";
import PasswordRules from "../components/PasswordRules";
import FormError from "../components/FormError";
import "./profile.css";
import "./auth.css";

const ChangePassword = () => {
  const [passwordFormData, setPasswordFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [passwordError, setPasswordError] = useState("");
  const [isChangingPassword, setIsChangingPassword] = useState(false);

  const navigate = useNavigate();

  const handlePasswordInputChange = (field) => (e) => {
    setPasswordFormData({
      ...passwordFormData,
      [field]: e.target.value,
    });
    setPasswordError("");
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setPasswordError("");

    if (
      !passwordFormData.currentPassword ||
      !passwordFormData.newPassword ||
      !passwordFormData.confirmPassword
    ) {
      setPasswordError("Please fill in all fields.");
      return;
    }

    if (passwordFormData.newPassword !== passwordFormData.confirmPassword) {
      setPasswordError("The passwords do not match.");
      return;
    }

    if (!isPasswordValid(passwordFormData.newPassword)) {
      setPasswordError("The password does not meet all requirements.");
      return;
    }

    setIsChangingPassword(true);

    try {
      await changePassword(
        passwordFormData.currentPassword,
        passwordFormData.newPassword,
        passwordFormData.confirmPassword
      );
      navigate("/profile", { state: { passwordChanged: true } });
    } catch (err) {
      setPasswordError(err.message || "Error changing password.");
      setIsChangingPassword(false);
    }
  };

  return (
    <div className="profile-page change-password-page">
      <FormContainer className="profile-card">
        <h1 className="profile-title">Change Password</h1>

        <form className="profile-password-form" onSubmit={handlePasswordSubmit}>
          <InputField
            id="currentPassword"
            type="password"
            label="Current Password"
            value={passwordFormData.currentPassword}
            onChange={handlePasswordInputChange("currentPassword")}
            required
          />

          <InputField
            id="newPassword"
            type="password"
            label="New Password"
            value={passwordFormData.newPassword}
            onChange={handlePasswordInputChange("newPassword")}
            required
          />

          <PasswordRules password={passwordFormData.newPassword} />

          <InputField
            id="confirmPassword"
            type="password"
            label="Confirm New Password"
            value={passwordFormData.confirmPassword}
            onChange={handlePasswordInputChange("confirmPassword")}
            required
          />

          {passwordError && <FormError message={passwordError} />}

          <div className="profile-actions profile-actions--edit">
            <Button
              type="submit"
              className="profile-button"
              disabled={isChangingPassword}
              loading={isChangingPassword}
              loadingText="Saving…"
            >
              Save Password
            </Button>
            <Button
              type="button"
              className="profile-button profile-button--cancel"
              onClick={() => navigate("/profile")}
            >
              Back to Profile
            </Button>
          </div>
        </form>
      </FormContainer>
    </div>
  );
};

export default ChangePassword;
